import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Loader2, Copy, Check } from 'lucide-react';
import { clientsApi } from '../api/organizations';

export default function ForgotPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [activationUrl, setActivationUrl] = useState<string | null>(null);
  const [copied, setCopied] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await clientsApi.forgotPassword(email);
      setSent(true);
      // MVP: до email-канала возвращаем ссылку прямо сюда
      if (r.activation_url) setActivationUrl(r.activation_url);
    } finally { setLoading(false); }
  };

  const copy = () => {
    if (!activationUrl) return;
    navigator.clipboard.writeText(activationUrl).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    });
  };

  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center p-6">
      <div className="bg-slate-900 border border-slate-800 rounded-xl p-8 w-full max-w-md">
        <h1 className="text-2xl font-bold text-white mb-1">Сброс пароля</h1>
        <p className="text-sm text-slate-400 mb-6">
          Укажите email — пришлём ссылку для установки нового пароля.
        </p>

        {sent ? (
          <div className="space-y-3">
            <div className="bg-emerald-900/20 border border-emerald-800 text-emerald-300 px-3 py-2 rounded text-sm">
              Если email найден — ссылка для сброса пароля сформирована.
            </div>
            {activationUrl && (
              <>
                <p className="text-xs text-slate-500">
                  В этой версии ссылка возвращается прямо сюда (email-канал
                  будет в следующей фазе).
                </p>
                <div className="bg-slate-950 border border-slate-700 rounded px-3 py-2 text-xs font-mono text-blue-300 break-all">
                  {activationUrl}
                </div>
                <button onClick={copy}
                  className="text-xs bg-slate-800 hover:bg-slate-700 text-slate-200 px-3 py-1.5 rounded inline-flex items-center gap-1.5">
                  {copied ? <><Check size={12} className="text-emerald-400" /> Скопировано</> : <><Copy size={12} /> Скопировать</>}
                </button>
              </>
            )}
            <Link to="/login" className="block text-center text-sm text-blue-400 hover:underline">
              ← К входу
            </Link>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <label className="block">
              <span className="block text-xs text-slate-400 uppercase tracking-wider mb-1">Email</span>
              <input type="email" required value={email} onChange={e => setEmail(e.target.value)}
                     className="w-full bg-slate-950 border border-slate-700 rounded px-3 py-2 text-sm text-white focus:border-blue-500 outline-none" />
            </label>
            <button type="submit" disabled={loading || !email}
                    className="w-full bg-blue-600 hover:bg-blue-500 disabled:bg-slate-700 text-white font-bold py-2 rounded inline-flex items-center justify-center gap-2">
              {loading && <Loader2 size={14} className="animate-spin" />}
              Прислать ссылку
            </button>
            <Link to="/login" className="block text-center text-xs text-slate-500 hover:text-slate-300">
              ← К входу
            </Link>
          </form>
        )}
      </div>
    </div>
  );
}
